import { Chip } from "@material-ui/core";
import {
  Activity,
  ActivityFeedItemDefinition,
} from "@ofqual/portal-activity-feed";
import React from "react";
import { ActivityType } from "../../../domain/ActivityType";
import { Qualification } from "../../../domain/Qualification";
import { fieldLabels } from "../../sections/fieldLabels";
import {
  ChangeActivityBody,
  AttachmentBodyProps,
  AttachmentActivityBody,
} from "./types";
import { DownloadLink } from "@ofqual/portal-components/components/DownloadLink";
import { useSelector } from "react-redux";
import { authSelector } from "../../../redux/selectors";
import { qualificationService } from "../../../services";
import ReactMarkdown from "react-markdown";

export const buildDefinitions = (
  setFocussedActivity: (activity: Activity) => void,
  qualification: Qualification
) => {
  const AttachmentBody: React.FC<AttachmentBodyProps> = ({ bodyProps }) => {
    const { body } = bodyProps;
    const { token } = useSelector(authSelector);

    const buildGetBlob = (blobId: string) => () =>
      qualificationService.downloadActivityDocument(
        qualification.id,
        bodyProps.activity.id,
        blobId,
        { token: token }
      );
    return (
      <>
        <ul style={{ padding: 0, marginLeft: 0, marginTop: 0 }}>
          {body.documents.map((document) => {
            if (document !== null) {
              return (
                <li key={document.blobId} style={{ listStyleType: "none" }}>
                  <DownloadLink
                    fileName={document.fileName}
                    getBlob={buildGetBlob(document.blobId)}
                  />
                </li>
              );
            } else {
              return <></>;
            }
          })}
        </ul>
      </>
    );
  };
  const qualificationUpdated: ActivityFeedItemDefinition<ChangeActivityBody> = {
    activityType: ActivityType.QualificationUpdated,
    Body: ({ body }) => (
      <>
        <b>Updated:</b>{" "}
        {body.changes.map((item) => (
          <Chip
            size="small"
            style={{ margin: 2, display: "flex-grid" }}
            label={fieldLabels[item.field]}
            className="ChangeChip"
            key={item.field}
          />
        ))}
      </>
    ),
    options: [
      {
        label: "Show Changes",
        onClick: setFocussedActivity,
      },
    ],
  };

  const messageSentRegulator: ActivityFeedItemDefinition<AttachmentActivityBody> = {
    activityType: ActivityType.QualificationSendMessageRegulator,
    Body: ({ body, activity }) => {
      return (
        <>
          {body.message ? (
            <div style={{ marginBottom: 15 }}>
              <b>Message: </b>
              <ReactMarkdown>{body.message}</ReactMarkdown>
            </div>
          ) : null}
          <AttachmentBody bodyProps={{ activity, body }} />
        </>
      );
    },
  };

  const messageSentAO: ActivityFeedItemDefinition<AttachmentActivityBody> = {
    activityType: ActivityType.QualificationSendMessageAO,
    Body: ({ body, activity }) => {
      return (
        <>
          {body.message ? (
            <div style={{ marginBottom: 15 }}>
              <b>Message: </b>
              <ReactMarkdown>{body.message}</ReactMarkdown>
            </div>
          ) : null}
          <AttachmentBody bodyProps={{ activity, body }} />
        </>
      );
    },
  };

  const ApprovalBody: React.FC<{
    response: string;
  }> = ({ response }) => {
    return (
      <>
        {response ? (
          <div style={{ marginBottom: 15 }}>
            <b>Message: </b>
            <ReactMarkdown>{response}</ReactMarkdown>
          </div>
        ) : null}
      </>
    );
  };

  const qualApprovedOfqual: ActivityFeedItemDefinition<{ response: string }> = {
    activityType: ActivityType.QualificationApprovedOfqual,
    Body: ({ body }) => {
      return <ApprovalBody response={body.response} />;
    },
  };

  const qualApprovedCcea: ActivityFeedItemDefinition<{
    response: string;
  }> = {
    activityType: ActivityType.QualificationApprovedCcea,
    Body: ({ body }) => {
      return <ApprovalBody response={body.response} />;
    },
  };

  const qualRejectedOfqual: ActivityFeedItemDefinition<{
    response: string;
  }> = {
    activityType: ActivityType.QualificationRejectedOfqual,
    Body: ({ body }) => {
      return <ApprovalBody response={body.response} />;
    },
  };

  const qualRejectedCcea: ActivityFeedItemDefinition<{
    response: string;
  }> = {
    activityType: ActivityType.QualificationRejectedCcea,
    Body: ({ body }) => {
      return <ApprovalBody response={body.response} />;
    },
  };

  const resubmitQual: ActivityFeedItemDefinition<{}> = {
    activityType: ActivityType.QualificationResubmitted,
  };

  return [
    qualificationUpdated,
    messageSentRegulator,
    messageSentAO,
    qualApprovedOfqual,
    qualApprovedCcea,
    qualRejectedOfqual,
    qualRejectedCcea,
    resubmitQual,
  ];
};
